import { render, staticRenderFns } from "./WriteGridContainer.vue?vue&type=template&id=ab487e36&scoped=true"
import script from "./WriteGridContainer.vue?vue&type=script&lang=js"
export * from "./WriteGridContainer.vue?vue&type=script&lang=js"
import style0 from "./WriteGridContainer.vue?vue&type=style&index=0&id=ab487e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab487e36",
  null
  
)

export default component.exports